import { render, staticRenderFns } from "./RadialChart.vue?vue&type=template&id=c1485e60&scoped=true"
import script from "./RadialChart.vue?vue&type=script&lang=js"
export * from "./RadialChart.vue?vue&type=script&lang=js"
import style0 from "./RadialChart.vue?vue&type=style&index=0&id=c1485e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1485e60",
  null
  
)

export default component.exports